export const colorsMap = {
    normal: '--secondary-text-color',
    secondary: '--secondary-text-color',
    active: '--active-color',
    critical: '--error-color',
    success: '--success-color',
    warning: '--warning-color',
    panel: '--panel-text-color'
};

export const stylesMap = {
    iconSizes: {
        main: '--main-icon-size',
        small: '--small-icon-size',
        tiny: '--tiny-icon-size'
    },
    fontSizes: {
        main: '--main-font-size',
        secondary: '--secondary-font-size',
        title: '--title-font-size',
        subtitle: '--subtitile-font-size',
        bigNumber: '--big-number-font-size'
    },
    lineHeights: {
        main: '--main-line-height',
        secondary: '--secondary-line-height',
        title: '--title-line-height',
        subtitle: '--subtitle-line-height',
        bigNumber: '--big-number-line-height'
    }
};
